<template>
  <div class="page-contratti-vendita-detail">
    <fornitori-detail />
  </div>
</template>

<script>
import FornitoriDetail from '@/components/ask/details/ContrattiVenditaDetail.vue'

export default {
  name: 'ViewContrattiVenditaDetail',
  components: {
    FornitoriDetail,
  },

  data() {
    return {
      pageName: 'ContrattiVenditaDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
